module.exports = __webpack_public_path__ + "static/img/Jacob-Host.8ab9e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jacob-Host.jpg
// module id = t4hj
// module chunks = 0